import $ from "jquery";
import 'slick-carousel';

const stepperSlider = () => {
  const sliderId = $("[data-slider='stepper-slider']").attr("id");
  const stepperSlider = $(`#${sliderId}`);
  const dotsClass = 'stepper'

  if (!stepperSlider.length) return;

  const updateGradientsState = (slick) => {
    const slickObj = slick ? slick : stepperSlider.slick('getSlick');
    if (!slickObj) return;

    const currentSlide = slickObj.currentSlide;
    const totalSlides = slickObj.slideCount;
    const slidesToShow = slickObj.options.slidesToShow;

    // Show left gradient only if NOT on first slide
    if (currentSlide > 0) {
      stepperSlider.addClass('has-gradient-left');
      stepperSlider.removeClass('has-gradient-right');
    } else {
      stepperSlider.removeClass('has-gradient-left');
    }

    // Show right gradient only if NOT on last slide
    if (currentSlide + slidesToShow < totalSlides) {
      stepperSlider.addClass('has-gradient-right');
      stepperSlider.removeClass('has-gradient-left');
    } else {
      stepperSlider.removeClass('has-gradient-right');
    }
  };

  stepperSlider.on('init', function(event, slick){
    updateGradientsState(slick);
  });

  // Check if the current viewport is mobile
  const isMobile = window.matchMedia("(max-width: 840px)").matches;

  if (stepperSlider.hasClass('slick-initialized')) {
    stepperSlider.slick('unslick');
  }

  stepperSlider.slick({
    infinite: false,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    cssEase: 'linear',
    speed: 350,
    arrows: false,
    dots: true,
    appendDots: $('.stepper-container'),
    dotsClass: dotsClass,
    vertical: false,
    verticalSwiping: false,
    horizontal: true,
    horizontalSwiping: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  const prevButton = $(`[data-slider="${sliderId}"][data-type="prev"]`);
  if (prevButton.length) {
    prevButton.on('click', function() {
      stepperSlider.slick('slickPrev');
    });
  }

  const nextButton = $(`[data-slider="${sliderId}"][data-type="next"]`);
  if (nextButton.length) {
    nextButton.on('click', function() {
      stepperSlider.slick('slickNext');
    });
  }

  const updateButtonsState = () => {
    if(!nextButton.length || !prevButton.length) return;

    const currentSlide = stepperSlider.slick('slickCurrentSlide');
    const slideCount = stepperSlider.slick('getSlick').slideCount;
    const slidesToShow = stepperSlider.slick('getSlick').options.slidesToShow;

    if(currentSlide === 0) {
      prevButton.prop('disabled', true);
    } else {
      prevButton.prop('disabled', false);
    }

    if(slideCount <= currentSlide + slidesToShow) {
      nextButton.prop('disabled', true);
    } else {
      nextButton.prop('disabled', false);
    }
  };

  const setStepperButtons = () => {
    const slideCount = stepperSlider.slick('getSlick').slideCount;
    const buttons = $(`.${dotsClass} button`);

    for (let i = 0; i < slideCount; i++) {
      const slide = $($(`#${sliderId} .stepper-slide`)[i]);
      let stepTitle = slide.data('step-title');
      if(!stepTitle || stepTitle === '') {
        stepTitle = slide.find('.h2-eyebrow').text();
      }

      stepTitle = stepTitle ? $.trim(stepTitle) : i;
      $(buttons[i]).text(stepTitle && stepTitle.length ? stepTitle : i + 1);
    }
  };

  setStepperButtons();
  updateButtonsState();

  stepperSlider.on('afterChange', function(event, slick, currentSlide) {
    updateButtonsState();
    updateGradientsState();
  });

  stepperSlider.on('updateTitle', setStepperButtons);

  $(window).on('orientationchange', function () {
    setTimeout(setStepperButtons, 100);
    updateGradientsState();
  });

  $(window).on("resize", function () {
    setTimeout(setStepperButtons, 100);
  });

};

export default stepperSlider;
